import { InputAdornment, styled, Typography } from '@mui/material';
import NumberInput from 'further-ui/components/NumberInput';
import {
  getCurrencySymbol,
  numberToCurrencyString,
  numberToPercentageString,
} from 'further-ui/utils';
import { round } from 'lodash';

const PercentageInput = styled(NumberInput)(() => ({ maxWidth: '9ch' }));

type Value = {
  percentage?: number;
  valueLcy?: number;
};

type Props = {
  readOnly: boolean;
  currencyLcy: string;
  value: Value;
  totalGeneralCall: number;
  onChange: (newValue: Value) => void;
  onBlur: () => void;
};

const RowValues: React.FC<Props> = ({
  value: { percentage, valueLcy },
  currencyLcy,
  readOnly,
  totalGeneralCall,
  onChange,
  onBlur,
}) => {
  const handleChange = (
    field: 'percentage' | 'value',
    value: number | null,
  ) => {
    const newValue = {
      percentage: (field === 'percentage' ? value : percentage) ?? 0,
      valueLcy: (field === 'value' ? value : valueLcy) ?? 0,
    };
    if (field === 'percentage') {
      newValue.valueLcy = round(
        (totalGeneralCall * newValue.percentage) / 100,
        2,
      );
    } else {
      newValue.percentage =
        totalGeneralCall === 0
          ? 0
          : (newValue.valueLcy / totalGeneralCall) * 100;
    }
    onChange(newValue);
  };

  return readOnly ? (
    <>
      <Typography variant="h6">
        {numberToPercentageString(percentage ?? 0)}
      </Typography>
      <Typography variant="h6">
        {numberToCurrencyString(valueLcy ?? 0, { currency: currencyLcy })}
      </Typography>
    </>
  ) : (
    <>
      <PercentageInput
        slotProps={{
          input: {
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          },
        }}
        value={percentage}
        fullWidth
        size="small"
        onChange={(value) => handleChange('percentage', value)}
        onBlur={onBlur}
      />
      <NumberInput
        value={valueLcy}
        fullWidth
        size="small"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                {getCurrencySymbol(currencyLcy)}
              </InputAdornment>
            ),
          },
        }}
        onChange={(value) => handleChange('value', value)}
        onBlur={onBlur}
      />
    </>
  );
};

export default RowValues;
